module.exports = __webpack_public_path__ + "img/CFvsIIAF.9a65a382.png";